import { Link } from "react-router-dom";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  to?: string;
  toLabel?: string;
}

export default function SectionHeading({
  eyebrow,
  title,
  description,
  to,
  toLabel = "查看全部",
}: SectionHeadingProps) {
  return (
    <div className="mb-6 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between md:mb-8">
      <div>
        {eyebrow && (
          <span className="inline-flex items-center gap-1.5 text-xs font-semibold uppercase tracking-[0.18em] text-accent-600">
            <span className="h-1 w-1 rounded-full bg-accent-500"></span>
            {eyebrow}
          </span>
        )}
        <h2 className="mt-2 font-heading text-xl font-bold text-foreground-950 md:text-2xl">{title}</h2>
        {description && <p className="mt-2 max-w-2xl text-sm text-foreground-500">{description}</p>}
      </div>
      {to && (
        <Link
          to={to}
          className="group inline-flex shrink-0 items-center gap-1 text-sm font-medium text-primary-600 transition-colors hover:text-primary-700"
        >
          {toLabel}
          <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5"></i>
        </Link>
      )}
    </div>
  );
}